import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextDirectionLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.864 5.76562H10.5913C8.13109 5.76562 6.13672 7.75999 6.13672 10.2202C6.13672 12.6803 8.13109 14.6747 10.5913 14.6747H11.2276",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.318 19.7656V5.76562",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2272 19.7656V5.76562",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTextDirectionLine;
